<mat-card style="padding: 20px">
    <mat-card-title style="text-align: center; margin: 10px">Delete the following file?</mat-card-title>
    <div style="text-align: center; font-size: large">{{ data.fileName }}</div>
    <mat-card-actions style="justify-content: center">
        <button mat-button color="warn" (click)="onCancel()">Cancel</button>
        <button mat-button color="primary" (click)="onConfirm()">Delete</button>
    </mat-card-actions>
</mat-card>
